import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type TemplateStat = {
  key: string;
  label: string;
  value: number;
};

type WhatsappTemplateListStatsProps = {
  stats: TemplateStat[];
};

export const WhatsappTemplateListStats: FC<WhatsappTemplateListStatsProps> = ({ stats }) => {
  const { t } = useTranslation('campaign');

  return (
    <div className='grid grid-cols-2 gap-3 sm:grid-cols-4'>
      {stats.map((item) => (
        <div key={item.key} className='space-y-1 rounded-2xl bg-gray-50 px-4 py-3'>
          <p className='text-[11px] font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t(item.label)}</p>
          <p className='text-2xl font-semibold text-slate-900'>{item.value}</p>
        </div>
      ))}
    </div>
  );
};
